import React from 'react';
import { AppProvider, Page, Card, Spinner, ResourceList } from '@shopify/polaris';
import { BasicTextField } from '@presentational';
import translations from '@shopify/polaris/locales/es.json';
import { courierColumns } from '@utils/recordHelpers';
import { ResourceTableHeaders, ResourceTableBody } from '@presentational';

const CourierIndexWrapper = (props) => (
  <AppProvider i18n={translations}>
    <Page
      title={I18n.t("activerecord.models.courier", { count: 2 })}
      primaryAction={
        props.newUrl ? {content: I18n.t("actions.create_x", { x: I18n.t("activerecord.models.courier.one")}), url: props.newUrl} : null
      }
    >
      <Card>
      <ResourceTableHeaders 
        columnsInfo={ courierColumns }
      />
      <ResourceTableBody 
        items={props.couriers}
        itemURL="/admin/couriers"
        urlAction="edit"
        columnsInfo={ courierColumns }
      />
      </Card>
    </Page>
  </AppProvider>
);

export default CourierIndexWrapper;
